import $ from 'jquery';
import HistoryManager from '../util/HistoryManager';

const SelectService = {
    callback: {
        onchange: {},
        onquery: {},
        oninput: {},
    },
    getControl(id) {
        const control = $(`.control--${id}`);
        const result = {
            id,
            dom: {
                control,
                select: control.find('.control-select'),
                value: control.find('.control-select__value'),
                anyValue: control.find('.control-select-body__any-value'),
                label: control.find('.control-select-body__label'),
                options: control.find('.control-select-option')
            },
            config: {
                name: control.attr('data-name'),
                placeholder: control.attr('data-placeholder'),
                isSubmit: control.hasClass('control--submit'),
                isQuery: control.hasClass('control--query'),
            },
            classnames: {
                selectEmpty: 'control-select--empty',
                optionSelected: 'control-select-option--selected'
            }
        };
        return result;
    },
    hide() {
        $('.control-select').removeClass('control-select--opened');
    },
    onChange(id, callback) {
        if (!this.callback.onchange[id]) {
            this.callback.onchange[id] = [];
        }
        this.callback.onchange[id].push(callback);
    },
    onInput(id, callback) {
        if (!this.callback.oninput[id]) {
            this.callback.oninput[id] = [];
        }
        this.callback.oninput[id].push(callback);
    },
    onQuery(id, callback) {
        this.callback.onquery[id] = callback;
    },
    onQueryDefault(name, value) {
        if (value === false) {
            HistoryManager.current().remove(name).apply();
        } else {
            HistoryManager.current().set(name, value).apply();
        }
    },
    triggerChange(id, value) {
        if (this.callback.onchange[id]) {
            this.callback.onchange[id].forEach((callback) => {
                callback(value);
            });
        }
    },
    triggerInput(id, value) {
        if (this.callback.oninput[id]) {
            this.callback.oninput[id].forEach((callback) => {
                callback(value);
            });
        }
    },
    triggerSubmit(id) {
        const control = this.getControl(id);
        control.dom.control.parents('form').submit();
    },
    getValue(id) {
        const control = this.getControl(id);
        const value = control.dom.value.val();


        return !value ? false : value;
    },
    setOptions(id, options, uniqueNames = false, sortBy = false) {
        const control = this.getControl(id);
        const optionsContainer = control.dom.control.find('.control-select-options');

        if (sortBy === 'id' || sortBy === 'name') {
            options = options.sort((a, b) => {return a[sortBy] > b[sortBy] ? 1 : -1});
        }

        const names = [];
        control.dom.options.remove();
        options.forEach(option => {
            let className = 'control-select-option';
            if (uniqueNames && names.indexOf(option.name) !== -1) {
                className += ' control-select-option--duplicate';
            }
            names.push(option.name);

            optionsContainer.append(`
                <div class="${className}" data-value="${option.id}">${option.name}</div>
            `);
        });

        optionsContainer.find('.control-select-search__field').val('');
    },
    getOptions(id) {
        return this.getControl(id).dom.options.toArray().map((option) => {
            return {
                id: option.dataset.value,
                name: option.innerText.trim(),
            }
        });
    },
    setValue(id, value, byUserInput = false) {
        const controlObject = this.getControl(id);
        let valueText = [];
        let inputValue = value;

        if (inputValue === false) {
            inputValue = '';
        }

        if (Array.isArray(inputValue)) {
            inputValue = JSON.stringify(inputValue);
        }

        controlObject.dom.value.val(inputValue);

        /*
            SET CONTROL STATE
        */
        controlObject.dom.options.removeClass(controlObject.classnames.optionSelected);
        const isAnyValue = controlObject.dom.anyValue.length > 0;
        if (value !== false) {
            controlObject.dom.select.removeClass(controlObject.classnames.selectEmpty);
            if (Array.isArray(value)) {
                value.forEach((optionId) => {
                    const optionDom = controlObject.dom.control.find(`.control-select-option[data-value="${optionId}"]`);
                    optionDom.addClass(controlObject.classnames.optionSelected);
                    valueText.push(optionDom.html());
                });
            } else {
                const optionDom = controlObject.dom.control.find(`.control-select-option[data-value="${value}"]`);
                valueText.push(optionDom.html());
                optionDom.addClass(controlObject.classnames.optionSelected);
            }
        } else {
            controlObject.dom.select.addClass(controlObject.classnames.selectEmpty);
            valueText = isAnyValue ? [] : [controlObject.config.placeholder];
        }
        valueText = valueText.map(val => val.trim()).join(',\n');
        controlObject.dom.label.html(valueText).parents('.control-select-body__text').attr('title', valueText);
        if (!byUserInput) {
            controlObject.dom.anyValue.val(valueText);
        }
        if (isAnyValue) {
            const hidePlaceholder = controlObject.dom.anyValue.val() !== '';
            controlObject.dom.control.find('.control-select-body__placeholder').toggleClass('hidden', hidePlaceholder);
        }

        /*
            QUERY
        */
        if (controlObject.config.isQuery) {
            if (this.callback.onquery[id]) {
                this.callback.onquery[id](controlObject.config.name, value);
            } else {
                this.onQueryDefault(controlObject.config.name, value);
            }
        }

        if (byUserInput) {
            this.triggerInput(id, controlObject.dom.anyValue.val());
        } else {
            this.triggerChange(id, value);
        }

        /*
            SUBMIT
        */
        if (controlObject.config.isSubmit) {
            this.triggerSubmit(id);
        }

        return {
            id,
            valueText,
            value
        };
    }
};
window.select = SelectService;
export default SelectService;
